define(['vendor/material.min.js', 'app/control/text_card'], function (mdl, text_card) {
  var class_active = 'is-active';

  var Tabs = function () {
    this.$tabs_content = $('.js-tabs');
    this.$tabs_links = this.$tabs_content.find('.js-tabs-link');
    this.$tabs_buttons = $('.js-tabs-button');
    this.$event = $({});
    this.hash = window.location.hash;
    this.$selectedLink = this.$tabs_content.find('.js-tabs-link[href="' + this.hash + '"]');

    if (this.$selectedLink.length) {
      var href = this.$selectedLink.attr('href');

      this.hideAllTabs();
      this.$selectedLink.addClass(class_active);
      this.showTab(href);
      this.$event.trigger('shown.tabs', {tab_id: href})
    }

    this.$tabs_links.on('click', function (event) {
      var $link = $(event.target);
      var href = $link.attr('href');
      event.preventDefault();
      if($link.hasClass(class_active)) return false;

      this.hideAllTabs();

      $link.addClass(class_active);
      this.showTab(href);

      this.$event.trigger('shown.tabs', {tab_id: href})

    }.bind(this));

    this.$tabs_buttons.on('click', function (e) {
      var $link = $(e.target);
      var href = $link.attr('href');
      e.preventDefault();
      this.hideAllTabs();
      $('.js-tabs-link[href="'+href+'"]').addClass(class_active);
      this.showTab(href)
      this.$event.trigger('shown.tabs', { tab_id: href });
    }.bind(this));

    return this;
  };

  Tabs.prototype.showTab = function (href) {
    this.$tabs_content.find(href).each(function () {
      $(this).addClass(class_active);
    });
  };

  Tabs.prototype.removeActiveClassLink = function () {
    this.$tabs_links.each(function () { $(this).removeClass(class_active) });
  };

  Tabs.prototype.hideAllTabs = function () {
    this.$tabs_content.find('.ca-company-tabs-item').each(function () {
      var tab = $(this);
      tab.removeClass(class_active);
    })

    this.removeActiveClassLink();
  };

  return Tabs;
});
